import React, { useEffect, useState } from 'react'

import { keyframes } from '@emotion/react'
import { styled } from '@mui/material/styles'

const EARTH_CIRCUMFERENCE_KM = 40075
const FALLBACK_DISTANCE_KM = 0
const REFETCH_INTERVAL_MS = 60 * 60 * 1000

const scrollTexture = keyframes`
  from { background-position: 0% 50%; }
  to { background-position: 200% 50%; }
`

const Globe = styled('div')`
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  background-image: url('/images/earth-texture.jpg');
  background-size: 200% 100%;
  animation: ${scrollTexture} 6s linear infinite;
  box-shadow:
    inset -3px -2px 6px rgba(0, 0, 0, 0.35),
    0 0 4px rgba(30, 120, 220, 0.25);
`

const Divider = () => (
  <span style={{ color: '#ccc', fontSize: '12px', margin: '0 10px' }}>|</span>
)

const formatKm = km => {
  const man = km / 10000
  return man % 1 === 0 ? `${man}万km` : `${man.toFixed(1)}万km`
}

export default function VrwcAnnouncementBar() {
  const [totalDistanceKm, setTotalDistanceKm] = useState(FALLBACK_DISTANCE_KM)

  useEffect(() => {
    const fetchDistance = async () => {
      try {
        const res = await fetch('/announcement_bar_distance.json', { cache: 'no-cache' })
        if (!res.ok) return
        const data = await res.json()
        if (typeof data.total_distance_km === 'number') {
          setTotalDistanceKm(data.total_distance_km)
        }
      } catch (e) {
        // 取得失敗時は前回値（初回はFALLBACK_DISTANCE_KM）を維持
      }
    }
    fetchDistance()
    const id = setInterval(fetchDistance, REFETCH_INTERVAL_MS)
    return () => clearInterval(id)
  }, [])

  const count = Math.floor(totalDistanceKm / EARTH_CIRCUMFERENCE_KM)

  return (
    <div
      style={{
        background: '#fff',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '7px 16px',
      }}
    >
      <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#212121', letterSpacing: '0.02em' }}>
        VRWC Run for All 開催中
      </span>
      <Divider />
      <span style={{ fontSize: '12px', color: '#555' }}>
        現在 <strong style={{ color: '#1565C0' }}>{formatKm(totalDistanceKm)}</strong> 達成中
      </span>
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        {Array.from({ length: count }).map((_, i) => (
          <Globe key={i} />
        ))}
      </div>
    </div>
  )
}
